import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {
  transform(number: string) {
    number = number || '';
    number = number.replace(/[^0-9]/g, '');
    let newStr = '';
    if (number.length === 11) {
      newStr = `(${number[0]})`;
      number = number.substring(1);
    }

    let i;
    for (i = 0; i < Math.floor(number.length / 3) - 1; i++) {
      newStr = newStr + number.substr(i * 3, 3) + '-';
    }
    return newStr + number.substr(i * 3);
  }
}
